module.exports = __webpack_public_path__ + "images/banners/question/hikakaku_q_banner_mb_bfded2069f10112afc2b9a6926ce2606.png";